export const GET_ADDRESSES = 'GET_ADDRESSES';